import { Card, CardContent } from '@material-ui/core';
import React from 'react';
import { skeleton } from '../../style';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => skeleton(theme));

const StateCardSkeleton = () => {
    const classes = useStyles();
    return (
        <Card>
            <CardContent style={{ padding: 0 }}>
                <div className={`${classes.skel} ${classes.skelStatusBanner}`} />
                <div className={classes.skelIdRow}>
                    <div className={`${classes.skel} ${classes.skelId}`} />
                    <div className={`${classes.skel} ${classes.skelPdfBtn}`} />
                </div>
                <div className={classes.skelInfoRows}>
                    {[0, 1, 2].map(i => (
                        <div key={i} className={classes.skelInfoRow}>
                            <div className={`${classes.skel} ${classes.skelInfoIcon}`} />
                            <div className={classes.skelInfoContent}>
                                <div className={`${classes.skel} ${classes.skelInfoKey}`} />
                                <div className={`${classes.skel} ${classes.skelInfoValue}`} />
                            </div>
                        </div>
                    ))}
                </div>
                <div className={classes.skelDividerSection}>
                    <div className={classes.skelRecapRow}>
                        <div className={`${classes.skel} ${classes.skelRecapKey}`} />
                        <div className={`${classes.skel} ${classes.skelRecapVal}`} />
                    </div>
                    <div className={classes.skelRecapRow}>
                        <div className={`${classes.skel} ${classes.skelRecapKey}`} />
                        <div className={`${classes.skel} ${classes.skelRecapVal}`} />
                    </div>
                    <div className={classes.skelRecapRow} style={{ marginTop: 6 }}>
                        <div className={`${classes.skel} ${classes.skelRecapKey}`} />
                        <div className={`${classes.skel} ${classes.skelTotalVal}`} />
                    </div>
                </div>
                <div className={classes.skelActions}>
                    <div className={`${classes.skel} ${classes.skelBtnMain}`} />
                    <div className={`${classes.skel} ${classes.skelBtnIcon}`} />
                </div>
            </CardContent>
        </Card>
    );
};

export default StateCardSkeleton;
